import React, { createContext, useState, useEffect } from "react";
import { getRandomColorPairFromColorWheel } from "../services/colors";
import { env } from "../datas.config";
import { initSocket, disconnectSocket, socket } from "../services/socket";
import { clearMessageCache } from "../services/messageCache";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [color, setColor] = useState(getRandomColorPairFromColorWheel());

  // Wrapper qui initialise le socket au moment du login
  const setUserAndSocket = (userData) => {
    if (userData) {
      initSocket();
    }
    setUser(userData);
  };

  const logout = async () => {
    try {
      await fetch(`${env.domain}/api/visitor/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("Erreur logout:", err);
    }
    // Quitter proprement la reunion avant de deconnecter le socket
    if (user && socket && socket.connected) {
      socket.emit("leave_meeting", user.userId);
    }
    disconnectSocket();
    clearMessageCache();
    setUser(null);
  };

  useEffect(() => {
    fetch(`${env.domain}/api/auth/me`, {
      credentials: "include",
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("Session invalide");
      })
      .then((data) => {
        setUserAndSocket(data.userData);
        setColor(data.userData.color);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        logout,
        setUser: setUserAndSocket,
        color,
        setColor,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
